import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPreview',
  props: {
    video: null
  },
  setup(__props: any) {



return { __sfc: true,AppButton }
}

})